import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useInstallation } from "@services/servicesGenericsTables";
import { Loading } from "@app/components";
import { useTransitDose } from "../utils/useTransitDose";

export default function TransitDosesListLayout() {
  const fetched = useRef(false);

  const { fetchAll, loading } = useTransitDose();
  const { fetchAll: fetchAllInstallation } = useInstallation();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      fetchAll();
      fetchAllInstallation();
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
